import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { HighlightRow } from "../../highlight-row";



declare var $: any;

@Component({
  selector: 'row-controls',
  templateUrl: './row-controls.component.html',
  styleUrls: ['./row-controls.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RowControlsComponent extends HighlightRow {

  @Input() item:any = undefined;

  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();

  constructor() { 
    super();
  }

  rowSave(e) {
    e.stopPropagation();
    this.onSave.emit();
  }

  rowEdit(e) {
    e.stopPropagation();
    this.setRow(this.item);
    this.onEdit.emit();
    $(e.target).parents('tr').addClass('row-edit selected').parents('tbody').addClass('tb-edit');
  }

  rowCancel(e) {
    e.stopPropagation();
    this.onCancel.emit();
    this.resetTbl();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/row-controls/row-controls.component.ts